import { SimilarityText } from "../../SimilarityText";

const CacheType = ({ cacheType }: { cacheType: string }) => {
  switch (cacheType) {
    case "original":
    case "similar":
      return <div>Cache</div>;
    case "miss":
      return <div>LLM</div>;
    default:
      return <div className="not-applicable-text">n/a</div>;
  }
};

interface CacheStatusViewColumnProps {
  cacheType: string;
  response: any;
}

export const CacheStatusViewColumn: React.FC<CacheStatusViewColumnProps> = ({
  cacheType,
  response,
}) => {
  return (
    <div className="svg-custom-column">
      <div className="fs-9 fw-500 d-flex align-items-center flex-nowrap desp">
        <SimilarityText
          cacheType={cacheType}
          score={response.similarityScore}
          hasSimilarPrompt={!!response.similarPromptId}
        />
      </div>
      <div className="two-lines-text">
        <CacheType cacheType={cacheType} />
      </div>
    </div>
  );
};
